import { render, staticRenderFns } from "./topComs.vue?vue&type=template&id=de862ea6&scoped=true&"
import script from "./topComs.vue?vue&type=script&lang=ts&"
export * from "./topComs.vue?vue&type=script&lang=ts&"
import style0 from "./topComs.vue?vue&type=style&index=0&id=de862ea6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de862ea6",
  null
  
)

export default component.exports